module.exports = __webpack_public_path__ + "img/call_us_48x48.1735418.svg";